function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "transparent",
  d: "M0 0h44v44H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 22,
  r: 20,
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M42 22.12C42 11.022 33.05 2 22.013 2 10.95 2 2 11.022 2 22.12 2 32.18 9.314 40.483 18.898 42V27.922h-5.122V22.12h5.122v-4.445c0-5.03 2.957-7.824 7.524-7.824 2.192 0 4.462.426 4.462.426v4.897h-2.508c-2.482 0-3.274 1.57-3.274 3.14v3.78h5.571l-.897 5.8h-4.674v14.053C34.687 40.483 42 32.153 42 22.12z",
  fill: "#1877F2"
});

function SvgIconFacebookColour(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQ0IiBoZWlnaHQ9IjQ0IiBmaWxsPSJ0cmFuc3BhcmVudCIvPgo8Y2lyY2xlIGN4PSIyMiIgY3k9IjIyIiByPSIyMCIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTQyIDIyLjExOThDNDIgMTEuMDIyIDMzLjA0OTUgMiAyMi4wMTMyIDJDMTAuOTUwNSAyIDIgMTEuMDIyIDIgMjIuMTE5OEMyIDMyLjE3OTYgOS4zMTM1MyA0MC40ODMgMTguODk3NyA0MlYyNy45MjE1SDEzLjc3NTZWMjIuMTE5OEgxOC44OTc3VjE3LjY3NTNDMTguODk3NyAxMi42NDU0IDIxLjg1NDggOS44NTA5NyAyNi40MjI0IDkuODUwOTdDMjguNjEzOSA5Ljg1MDk3IDMwLjg4NDUgMTAuMjc2OCAzMC44ODQ1IDEwLjI3NjhWMTUuMTczN0gyOC4zNzYyQzI1Ljg5NDQgMTUuMTczNyAyNS4xMDIzIDE2Ljc0MzggMjUuMTAyMyAxOC4zMTRWMjIuMDkzMUgzMC42NzMzTDI5Ljc3NTYgMjcuODk0OUgyNS4xMDIzVjQxLjk0NjhDMzQuNjg2NSA0MC40ODMgNDIgMzIuMTUzIDQyIDIyLjExOThaIiBmaWxsPSIjMTg3N0YyIi8+Cjwvc3ZnPgo=";
export { SvgIconFacebookColour as ReactComponent };